export const parseResourceRoom = (roomResources: any, facilities: any) => {
  if (!roomResources) {
    return null
  }

  return {
    ...roomResources,
    roomTypeFacility: !Array.isArray(roomResources?.roomTypeFacility) ? roomResources?.roomTypeFacility : Object.keys(facilities).reduce((obj, groupKey) => {
      const group = facilities[groupKey]
      const facilitiesIds = Object.keys(group)
      obj[groupKey] = facilitiesIds.reduce((obj1: any, facilityId: any) => {
        if ((roomResources?.roomTypeFacility || []).find((f: any) => `${f.propertyId}` === `${facilityId}`)) {
          obj1[facilityId] = { ...group[facilityId] }
        }
        return obj1
      }, {} as any)

      return obj
    }, {} as any)
  }
}